var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystoreButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 65,
    viewBox: "0 0 212 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M659.176,1106.051H846.682a12.366,12.366,0,0,1,12.247,12.483h0v40.031a12.368,12.368,0,0,1-12.247,12.484H659.176a12.368,12.368,0,0,1-12.247-12.484v-40.031a12.368,12.368,0,0,1,12.247-12.484",
    transform: "translate(-646.929 -1106.05)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M719,1145.638l-5.763,5.734-16.9-17.254a2.84,2.84,0,0,1,2.93-.021Z",
    transform: "translate(-670.633 -1119.161)",
    fill: "#0eec75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M718.671,1173.709,698.8,1185.333a2.856,2.856,0,0,1-3.439-.411l17.411-17.254Z",
    transform: "translate(-670.165 -1135.266)",
    fill: "#f43349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M740.472,1165.063l-5.7,3.332-.045.026-5.9-6.041,5.763-5.734.044.027,5.839,3.415a2.879,2.879,0,0,1,0,4.974",
    transform: "translate(-686.222 -1130.074)",
    fill: "#fcc701"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M694.548,1169.51l-.036-.035a2.906,2.906,0,0,1-.845-2.071V1137a2.9,2.9,0,0,1,1.346-2.475l.044-.027,16.9,17.5Z",
    transform: "translate(-669.352 -1119.7)",
    fill: "#00cffc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M801.14,1168.862h-8.266v2.3h5.792a6.02,6.02,0,1,1-1.729-6.016l1.62-1.624a8.319,8.319,0,1,0,2.61,6.057q0-.36-.028-.712",
    transform: "translate(-712.937 -1132.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M824.034,1172.581a5.354,5.354,0,1,0,5.3,5.408c0-.018,0-.036,0-.055a5.33,5.33,0,0,0-5.3-5.353m0,8.581a3.152,3.152,0,1,1,2.894-3.392c.006.083.01.166.01.249A3.03,3.03,0,0,1,824.034,1181.161Z",
    transform: "translate(-729.302 -1137.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M846.722,1172.581a5.354,5.354,0,1,0,5.3,5.408c0-.018,0-.036,0-.055a5.33,5.33,0,0,0-5.3-5.353m0,8.581a3.152,3.152,0,1,1,2.894-3.392c.006.083.01.166.01.249A3.03,3.03,0,0,1,846.722,1181.161Z",
    transform: "translate(-740.187 -1137.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 2.29,
    height: 16.806,
    transform: "translate(124.051 29.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M900.259,1179.232a3.124,3.124,0,0,1-5.277.547l7.779-3.055-.115-.405c-.045-.15-.1-.3-.15-.439a5.431,5.431,0,1,0-.149,4.3l.2-.429-2.091-.921Zm-.718-3.7-5.2,2.042a3.157,3.157,0,0,1,.25-.966,3.123,3.123,0,0,1,4.956-1.076Z",
    transform: "translate(-764.506 -1137.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M871.717,1172.581v.943a4.448,4.448,0,0,0-2.725-.943,5.384,5.384,0,0,0,0,10.712,4.458,4.458,0,0,0,2.725-.943v1.151a2.52,2.52,0,0,1-2.541,2.5l-.095,0a2.908,2.908,0,0,1-2.766-1.936l-2.075.97s.78,3.056,5.05,3.056a4.34,4.34,0,0,0,4.112-2.579,6.087,6.087,0,0,0,.609-2.694v-10.234Zm-2.725,8.581a3.189,3.189,0,1,1,2.631-3.143A2.921,2.921,0,0,1,868.992,1181.162Z",
    transform: "translate(-751.149 -1137.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1005",
    "data-name": "Rectangle 1005",
    width: 2.29,
    height: 16.806,
    transform: "translate(146.19 29.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M938.5,1161.261v2.3a3.152,3.152,0,0,1,0,6.286v2.126a5.356,5.356,0,1,0,0-10.712Z",
    transform: "translate(-786.816 -1132.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 3.846,
    height: 2.295,
    transform: "translate(147.839 28.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 3.846,
    height: 2.126,
    transform: "translate(147.839 37.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 2.29,
    height: 16.806,
    transform: "translate(158.182 29.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M963.993,1182.189l.281-.3v1.612H966.2v-6.936a5.434,5.434,0,0,0-.23-1.675,2.512,2.512,0,0,0-.711-1.117,3.131,3.131,0,0,0-1.262-.648,7.99,7.99,0,0,0-3.112-.116,8.117,8.117,0,0,0-1.088.261,6.09,6.09,0,0,0-.768.3l.122,1.817c.141-.071.3-.146.476-.231a7.36,7.36,0,0,1,.969-.345,4.665,4.665,0,0,1,1.268-.158,3.177,3.177,0,0,1,.922.115,1.425,1.425,0,0,1,.635.381,1.519,1.519,0,0,1,.346.638,3.288,3.288,0,0,1,.1.84v.749h-1.105a11.449,11.449,0,0,0-2.23.193,4.731,4.731,0,0,0-1.575.576,2.538,2.538,0,0,0-.922.968,2.952,2.952,0,0,0-.311,1.4,3.188,3.188,0,0,0,.247,1.3,2.536,2.536,0,0,0,.691.921,3.038,3.038,0,0,0,1.06.568,4.611,4.611,0,0,0,1.365.193,3.8,3.8,0,0,0,1.625-.346,4.255,4.255,0,0,0,1.281-.951m-1.2-.619a2.155,2.155,0,0,1-1.14.317,1.694,1.694,0,0,1-1.176-.39,1.38,1.38,0,0,1-.438-1.075,1.593,1.593,0,0,1,.152-.708,1.382,1.382,0,0,1,.483-.535,2.314,2.314,0,0,1,.815-.318,5.874,5.874,0,0,1,1.16-.1h1.2v1.874l-.041.046a4.543,4.543,0,0,1-1.016.889",
    transform: "translate(-796.038 -1137.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M984.216,1172.928l-1.674,3.879-1.029,2.385-.691-1.613-2.006-4.649h-2.494l3.254,7.541.725,1.682-1.889,4.626h2.5l1.642-4.185,1.247-2.893,2.922-6.772Z",
    transform: "translate(-804.961 -1137.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M807.246,1141.889a.776.776,0,0,1-.013.147.311.311,0,0,1-.042.115.2.2,0,0,1-.067.068.153.153,0,0,1-.083.022h-3.888a.409.409,0,0,1-.237-.086.365.365,0,0,1-.122-.319v-7.511a.365.365,0,0,1,.122-.318.411.411,0,0,1,.237-.086h3.829a.162.162,0,0,1,.083.022.181.181,0,0,1,.064.068.379.379,0,0,1,.038.115.8.8,0,0,1,.012.158.71.71,0,0,1-.012.149.346.346,0,0,1-.038.106.194.194,0,0,1-.064.065.165.165,0,0,1-.083.023h-3.406v2.925h2.936a.173.173,0,0,1,.09.022.19.19,0,0,1,.064.064.317.317,0,0,1,.038.11.839.839,0,0,1,.013.157.715.715,0,0,1-.013.145.291.291,0,0,1-.038.1.16.16,0,0,1-.064.057.2.2,0,0,1-.09.02h-2.937v3.318h3.464a.164.164,0,0,1,.083.023.215.215,0,0,1,.067.065.286.286,0,0,1,.041.115.857.857,0,0,1,.015.14",
    transform: "translate(-721.707 -1119.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M819.141,1134.267a.8.8,0,0,1-.013.149.347.347,0,0,1-.038.106.184.184,0,0,1-.063.064.171.171,0,0,1-.083.024h-2.476v7.486a.126.126,0,0,1-.084.123.537.537,0,0,1-.122.032,1.35,1.35,0,0,1-.372,0,.537.537,0,0,1-.122-.032.133.133,0,0,1-.064-.052.138.138,0,0,1-.02-.072v-7.486h-2.475a.159.159,0,0,1-.086-.024.2.2,0,0,1-.061-.064.323.323,0,0,1-.038-.106.7.7,0,0,1-.012-.149.789.789,0,0,1,.012-.158.378.378,0,0,1,.038-.115.192.192,0,0,1,.061-.068.156.156,0,0,1,.086-.022h5.734a.163.163,0,0,1,.083.022.185.185,0,0,1,.063.068.377.377,0,0,1,.038.115.844.844,0,0,1,.015.158",
    transform: "translate(-726.609 -1119.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M833.833,1142.066a.135.135,0,0,1-.02.07.129.129,0,0,1-.065.052.554.554,0,0,1-.115.032,1.415,1.415,0,0,1-.375,0,.554.554,0,0,1-.122-.032.126.126,0,0,1-.084-.122V1134a.117.117,0,0,1,.022-.07.151.151,0,0,1,.07-.052.6.6,0,0,1,.122-.032,1.067,1.067,0,0,1,.176-.013,1.084,1.084,0,0,1,.189.013.531.531,0,0,1,.115.032.127.127,0,0,1,.084.122Z",
    transform: "translate(-736.225 -1119.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M843.223,1134.267a.785.785,0,0,1-.013.149.323.323,0,0,1-.039.106.179.179,0,0,1-.063.064.17.17,0,0,1-.083.024h-2.476v7.486a.135.135,0,0,1-.019.072.131.131,0,0,1-.064.052.536.536,0,0,1-.122.032,1.351,1.351,0,0,1-.373,0,.537.537,0,0,1-.122-.032.134.134,0,0,1-.065-.052.136.136,0,0,1-.019-.072v-7.486h-2.476a.159.159,0,0,1-.086-.024.2.2,0,0,1-.061-.064.324.324,0,0,1-.038-.106.805.805,0,0,1-.013-.149.9.9,0,0,1,.013-.158.374.374,0,0,1,.038-.115.193.193,0,0,1,.061-.068.157.157,0,0,1,.086-.022h5.734a.163.163,0,0,1,.083.022.181.181,0,0,1,.063.068.359.359,0,0,1,.039.115.881.881,0,0,1,.014.158",
    transform: "translate(-738.163 -1119.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M863.329,1137.871a6.642,6.642,0,0,1-.231,1.8,3.837,3.837,0,0,1-.684,1.376,3.028,3.028,0,0,1-1.152.878,4.423,4.423,0,0,1-3.2.016,2.8,2.8,0,0,1-1.09-.836,3.573,3.573,0,0,1-.628-1.328,7.08,7.08,0,0,1-.2-1.768,6.525,6.525,0,0,1,.225-1.774,3.706,3.706,0,0,1,.684-1.361,3.075,3.075,0,0,1,1.152-.871,3.93,3.93,0,0,1,1.62-.309,3.878,3.878,0,0,1,1.565.289,2.835,2.835,0,0,1,1.094.83,3.554,3.554,0,0,1,.64,1.312,6.7,6.7,0,0,1,.211,1.743m-.833.07a6.6,6.6,0,0,0-.138-1.383,3.234,3.234,0,0,0-.461-1.125,2.228,2.228,0,0,0-.844-.752,2.8,2.8,0,0,0-1.3-.273,2.7,2.7,0,0,0-1.3.286,2.418,2.418,0,0,0-.858.768,3.21,3.21,0,0,0-.475,1.125,6.2,6.2,0,0,0-.144,1.357,7.13,7.13,0,0,0,.132,1.411,3.219,3.219,0,0,0,.446,1.135,2.182,2.182,0,0,0,.84.755,2.838,2.838,0,0,0,1.315.273,2.706,2.706,0,0,0,1.315-.293,2.415,2.415,0,0,0,.859-.784,3.314,3.314,0,0,0,.468-1.138,6.411,6.411,0,0,0,.145-1.361Z",
    transform: "translate(-747.301 -1119.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M879.61,1141.842a.454.454,0,0,1-.036.193.361.361,0,0,1-.09.125.316.316,0,0,1-.122.068.48.48,0,0,1-.126.02h-.16a.8.8,0,0,1-.231-.032.611.611,0,0,1-.2-.115,1.143,1.143,0,0,1-.2-.215,3.745,3.745,0,0,1-.221-.345l-2.924-5.2q-.218-.379-.439-.781t-.421-.781h-.006c0,.312.006.633.006.962v6.35a.13.13,0,0,1-.019.07.135.135,0,0,1-.063.052.613.613,0,0,1-.116.032,1.146,1.146,0,0,1-.189.012,1.246,1.246,0,0,1-.186-.012.59.59,0,0,1-.122-.032.137.137,0,0,1-.065-.052.14.14,0,0,1-.019-.07v-7.787a.365.365,0,0,1,.121-.319.409.409,0,0,1,.238-.087h.32a1.082,1.082,0,0,1,.258.026.521.521,0,0,1,.185.087.766.766,0,0,1,.164.174,3.024,3.024,0,0,1,.176.287l2.239,3.981q.211.373.4.716t.369.675c.12.221.239.439.356.653s.233.431.346.649h.007q-.006-.54-.007-1.125v-5.967a.13.13,0,0,1,.019-.07.155.155,0,0,1,.065-.055.382.382,0,0,1,.115-.032,1.5,1.5,0,0,1,.189-.009,1.453,1.453,0,0,1,.18.009.407.407,0,0,1,.122.032.173.173,0,0,1,.068.055.12.12,0,0,1,.023.07Z",
    transform: "translate(-755.705 -1119.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M784.64,1138.14a4.061,4.061,0,0,0,8.122,0v-.173H788.9v.792h3.03l-.066.243a3.276,3.276,0,1,1-1.081-3.4l.56-.562a4.057,4.057,0,0,0-6.7,3.1Z",
    transform: "translate(-712.998 -1119.363)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreButton);
export default __webpack_public_path__ + "static/media/PlaystoreButton.12f1d6bb95193d6044cf0d9a26a5d0db.svg";
export { ForwardRef as ReactComponent };